import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import type { SolidParticle } from '@babylonjs/core/Particles/solidParticle';

import { LinearPatternFeature } from '@kb3d/models/classes/features/linear-pattern-feature';
import type { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { PatternGeometryProcessor } from './pattern-geometry';
import { ProcessorData } from './base-processor';

export class LinearPatternGeometryProcessor extends PatternGeometryProcessor<LinearPatternFeature> {
    updateMeshGeometry(
        feature: LinearPatternFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>,
        dependencyData: ProcessorData<never>
    ) {
        const featureTranslation = feature.translation.toVec3();
        const workingVector = Vector3.Zero();

        return super.updateMeshGeometry(
            feature,
            vertexData,
            vertexDataChanges,
            dependencyData,
            (idx: number, particle: SolidParticle) => {
                if (!feature.meshId) {
                    workingVector.copyFrom(featureTranslation).scaleInPlace(idx);
                }
                particle.position.addInPlace(workingVector);
            }
        );
    }
}
